module.exports = __webpack_public_path__ + "img/behans.0ed313c7.png";